<template>
<div class="m-module">
    <div class="section">
        <div class="page-title">
            {{$t("lang.Profile")}}
        </div>
        <div class="mod">
            <div class="bd">
                <div class="userinfo">
                    <div class="avatar-wrapper">
                        <img :src="avatar ? avatar:require('@/assets/avatar.jpg')" class="avatar" />
                    </div>
                    <div class="info">
                        <div class="email">{{ userInfo.email }}</div>
                        <div class="Referral"> {{ $t('lang.Referral') }}：{{ userInfo.inviteCode }} <i class="icon el-icon-copy-document" @click="handleCopy(userInfo.inviteCode)"></i></div>
                        <van-uploader :after-read="afterRead"  :headers="headers" :action="modifyHeadImg">
                            <van-button type="default" size="small">
                                {{$t("lang.EditProfilePhoto")}}
                                <van-icon name="arrow" />
                            </van-button>
                       </van-uploader>
                       <!-- <span class="Referral">{{ $t('lang.Referral') }}：{{ userInfo.inviteCode }} <i class="icon el-icon-copy-document" @click="handleCopy(userInfo.inviteCode)"></i></span> -->
                    </div>
                </div>
                <div class="">
                    
                </div>
            </div>
        </div>
        <van-cell-group>
            <van-cell :title="$t('lang.ViewInvitationCode')" is-link @click="$router.push({name:'invite-m'})" />
             <div class="Invitation"  element-loading-spinner="el-icon-loading" v-if="!userInfo.parentInviteCode">
                <el-form>
                    <el-form-item class="form-item" >
                        <el-input v-model="form.inviteCode" :placeholder="$t('lang.referral')" maxlength="6" >
                            <template slot="append">
                                <el-button class="bt" type="primary"   @click="playInviteCode()">{{ $t('lang.Referral') }}</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
               </el-form>
            </div>
        </van-cell-group>
        
    </div>
</div>
</template>
<script>
import Header from "@/components/mobile/header";
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet,axiosPost} from '@/api/api';
import EventBus from '@/utils/EventBus'
import { Toast } from 'vant';

export default {
    name:'center-m',
    components: {
        Header,
    },
    data(){
        return {
            api:BASE_GLOB_API,
            url:{
                info:BASE_GLOB_API+'/user/info',
                modifyHeadImg:BASE_GLOB_API+'/user/modifyHeadImg',
                inviteCode:BASE_GLOB_API+'/user/bind/inviteCode',
            },
            modifyHeadImg:BASE_GLOB_API+'/user/modifyHeadImg',
            lang: "",
            userInfo:{},
            avatar:'',
            headers:{},
            form:{
                inviteCode:''
            }
        }
    },
    mounted(){
       
    },
    created(){
      this.lang = sessionStorage.getItem("Language")
      this.headers['X-Access-Token'] = window.localStorage.getItem('Token')
      this.platform()
    },
    methods:{
        handleCopy(content){
            this.$copyText(content).then(res=>{
                Toast.success(this.$t("lang.replicationSuccessful"))
            },
            err => {
                Toast.fail(this.$t("lang.replicationFailed"))
            })
        },
        playInviteCode(){
            if(!this.form.inviteCode){
                this.$message.error(this.$t("lang.referral"));
                return;
            }
          
            axiosPost(this.url.inviteCode,{inviteCode:this.form.inviteCode}).then(res=>{
                if(res.code == 200){
                    this.form.inviteCode =''
                    this.platform()
                }else{
                    this.$message.error(res.message);
                }
              
            })
        },
        afterRead(file) {
            console.log("file",file);
        
            let data = new FormData();
            data.append("headImgFile", file.file);
            axiosPost(this.modifyHeadImg, data).then(res=>{
                if(res.code == 200){
                    this.platform()
                }
              
            })
        },
        platform(){
            axiosGet(this.url.info).then(res=>{
               if(res.code ==200){
                   this.userInfo =res.result
                   if(this.userInfo.headImg){
                     this.avatar =this.api + this.userInfo.headImg
                    }else{
                     this.avatar =''
                    }
                    let userinfo = {
                        id:this.userInfo.id,
                        account:this.userInfo.account,
                        nikeName:this.userInfo.nikeName,
                        avatar:this.userInfo.headImg,
                        email:this.userInfo.email,
                    }
                    window.sessionStorage.setItem("userinfo", JSON.stringify(userinfo));
                    EventBus.$emit('img',  this.userInfo);
               }else{
                    this.$message.error(res.message);
                }
            })
           
        }, 
    }
}
</script>
<style lang="less" scoped>
.m-module {
    .section {
        .page-title {
            font-size:20px; font-weight:600; padding:30px 15px;
        }
        .mod {
            margin-bottom:16px;
           .bd {
                background:#fff; padding:16px;
                .userinfo {
                    display:flex; justify-content: flex-start; align-items: center; margin-bottom:10px;
                    .avatar-wrapper {
                        width:88px; height:88px; min-width:49px; margin-right:10px;
                        .avatar {
                            width:100%; height:100%; border-radius:50%;
                        }
                    }
                    .info {
                        .email {
                            font-size:18px; font-weight:700; margin-bottom:10px;
                        }
                        .Referral{
                            padding: 2px 0 15px 5px
                        }
                    }
                }
           } 
        }
        .Invitation{
            padding: 3px 15px;margin-top:20px ;
           .bt{
            color: #fff;
           }
        }
        
    }
}
</style>